module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/color-profile-b724cab7d2963fb05c2b19e84cc0b8ec.svg";